import React, { useState } from 'react'

export default function SelectOptionsModal(props) {
    const [newOption, setNewOption] = useState('')
    const [options, setOptions] = useState(props.options)

    const handleOptionChange = (value) => {
        setOptions([...options, newOption])
        setNewOption('')
    }

    const removeOption = (option) => {
        let newOptions = options.filter(op => op !== option)
        setOptions(newOptions)
    }
  return (
    <div>
        <div className="align-content-center align-items-center animated d-flex fadeIn h-100 justify-content-center position-fixed w-100 line-item-modal">
            <div className="bg-white mx-auto rounded shadow p-5 text-center cu-width-input">
                <h4>Select Options</h4>
                <div>
                    {options && options.map(option => (
                        <div key={option} className='d-flex justify-content-between align-items-center mb-2'>
                            <p>{option}</p>
                            <button onClick={() => removeOption(option)} type='button' className='btn btn-icon btn-outline-danger' >
                                <i className='fa fa-trash'></i>
                            </button>
                        </div>
                    ))}
                </div>

                <div className='row'>
                    <div className='col-md-12'>
                        <div className='form-group'>
                            <label htmlFor='new_option'>Add Option</label>
                            <input type='text' className='form-control' name='new_option' id='new_option' placeholder='Add a new option here' 
                                value={newOption} onChange={(event) => setNewOption(event.target.value)}
                            />
                        </div>
                    </div>
                </div>

                <div className="pt-3">
                    <button onClick={() => handleOptionChange(newOption)} type="button" className="btn btn-primary mr-2" disabled={!newOption}>
                        Add Option
                    </button>

                    <button onClick={() => props.handleClose(props.field, options)} type="button" className="btn btn-secondary mr-2">
                        Close
                    </button>
                </div>
            </div>
        </div>
    </div>
  )
}
